import { FetchStatus } from '@powdr/constants';

import { PLACES_PENDING, PLACES_SUCCESS, PLACES_ERROR } from '../types';

const initialState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLACES_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case PLACES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FetchStatus.SUCCESS,
      };
    case PLACES_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
